
import { AdminUser } from '@/api/types/admin-api-types';

/**
 * Map database schema to AdminUser frontend model
 */
export function mapDbSchemaToAdmin(dbAdmin: any): AdminUser {
  return {
    id: dbAdmin.id,
    email: dbAdmin.email,
    role: dbAdmin.role,
    created_at: dbAdmin.created_at
  };
}

/**
 * Map AdminUser frontend model to database schema
 */
export function mapAdminToDbSchema(admin: Partial<AdminUser>) {
  return {
    id: admin.id,
    email: admin.email,
    role: admin.role,
    created_at: admin.created_at
  };
}
